import privacy from "./privacy";
import dataRights from "./dataRights";
import cookies from "./cookies";
import shipping from "./shipping";
import deliveryIssues from "./deliveryIssues";
import returnsRefunds from "./returnsRefunds";
import cancellations from "./cancellations";
import internationalCustoms from "./internationalCustoms";
import paymentsPricingFraud from "./paymentsPricingFraud";
import discountsPromotions from "./discountsPromotions";
import clearanceFinalSale from "./clearanceFinalSale";
import productInformation from "./productInformation";
import productSafetyCare from "./productSafetyCare";
import reviewsContent from "./reviewsContent";
import intellectualProperty from "./intellectualProperty";
import accessibility from "./accessibility";
import packagingSustainability from "./packagingSustainability";
import complaintsDisputes from "./complaintsDisputes";
import policyUpdates from "./policyUpdates";
import terms from "./terms";
import faq from "./faq";

export const policies = [privacy, dataRights, cookies, shipping, deliveryIssues, returnsRefunds, cancellations,
  internationalCustoms, paymentsPricingFraud, discountsPromotions, clearanceFinalSale, productInformation,
  productSafetyCare, reviewsContent, intellectualProperty, accessibility, packagingSustainability,
  complaintsDisputes, policyUpdates, terms, faq];

export const policyBySlug = Object.fromEntries(policies.map((policy) => [policy.slug, policy]));

